<template>
  <v-card >
    <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
        <span> {{ $t("agenda.lblEmailTemplateSelection") }}</span>
        <v-spacer></v-spacer>
        <CloseIcon @click="close()" />
        </v-toolbar>
    </v-banner>
    <v-card-text style="max-height: 65vh; overflow-y: auto;" class="template-table-card-text">
        <p>
            {{ $t("agenda.lblTemplateSelectionMessage", {title: heading}) }}
        </p>
        <a-data-table
        :headers="headers"
        :items="templateItems"
        item-key="value"
        dense
        :no-data-text="$t('noData')"
        :no-results-text="$t('emptySearchRecords')"
        :disable-sort="true"
        :hide-default-footer="true"
        :items-per-page="50"
        >
        <template v-slot:[`item.emailSubject`]="{ item }">
            <div class="subject-text-box">{{ item.subject }}</div>
        </template>
        <template v-slot:[`item.#`]="{ item }">
            <v-radio-group
            v-model="selectedId"
            row
            dense
            >
            <v-radio :value="item.id"></v-radio>
            </v-radio-group>
        </template>
        </a-data-table>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            class="mr-2"
            color="primaryDark"
            small
            v-bind="attrs"
            v-on="on"
            @click="nextStep"
            ><span>{{ $t("Next") }}</span>
          </a-btn>
        </template>
        <span> {{ $t("Next") }} </span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            color="secondary"
            small
            @click="close()"
            v-bind="attrs"
            v-on="on"
            ><span>{{ $t("btnCancel") }}</span>
          </a-btn>
        </template>
        <span> {{ $t("btnCancel") }} </span>
      </v-tooltip>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "EmailNotificationTemplates",
  data() {
    return {
      isValidAttachment: true,
      templateItems: [],
      selectedId: null,
      headers: [
            {
            "text": "#",
            "value": "#",
            "width": "4%",
            "class": "header header-text"
            },
            {
            "text": this.$t("admin.lblEmailSubject"),
            "value": "emailSubject",
            "class": "header header-text",
            },
        ]
    };
  },
  components: {
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    section: {
      type: String,
      default: null,
    },
    selectedTemplateId: {
      type: String,
      default: null,
    },
  },
   computed: {
    ...mapGetters({
      masterSettingTypes: "tenant/masterSettingTypes",
      tenantSettingConfig: "tenant/tenantSettingConfig",
    }),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
     heading(){
        return this.section === 'ConvocationMail' ? 'Convocation Mail' : 'Remind Voting Consent';
    },
    
    selectedLang() {
      return this.$i18n.locale;
    },
    defaultEmailTemplates() {
      const defaultTemplate = this.masterSettingTypes(
        "default_email_templates"
      );
      return defaultTemplate;
    },
    emailTemplates() {
      return this.tenantSettingConfig("email_templates")?.email_templates || [];
    },
    emailTemplateTypes() {
      const items = this.masterSettingTypes("email_template_names");
      return items.map((item) => {
        return {
          id: item.id,
          name: this.$t(`template.${item.key}`),
        };
      });
    },
  },
  watch: {
   templateItems(values) {
      const activeItem = values.find((item) => item.active);
      if (activeItem) {
        this.selectedId = activeItem.id;
      }
    },
  },
  async mounted() {
    try {
      this.selectedId = this.selectedTemplateId;
      this.$store.commit('variables/setCashMasterConfigList', false);
      await this.getMasterConfigList();
      //await this.getDefaultEmailTemplates();
      this.templateItems = this.getTemplateByType(this.section);
  } catch (error) {
    console.log(error);
  }
  },
 methods: {
    ...mapActions({
      getTenantConfigList: "tenant/getTenantConfigList",
      getMasterConfigList: "tenant/getMasterConfigList",
      getDefaultEmailTemplates: "tenant/getDefaultEmailTemplates",
    }),
    close() {
      this.$emit("close", false);
      this.$emit("input", false);
    },
    getTemplateByType() {
    const parentKey = this.section;
    let userTemplates = [];
    if (this.emailTemplates.hasOwnProperty(parentKey)) {
        // Return the values of the nested object as an array
        userTemplates = Object.values(this.emailTemplates[parentKey]);
    }

    const isAnyActive = userTemplates.some((t) => t.active === true);
    const data = this.defaultEmailTemplates.filter(
        (t) => t.template_type === parentKey && t.language === this.selectedLang
    );
    const defaultTemplate = data.map((obj) => {
        return { ...obj, default: true, active: !isAnyActive };
    });

    const templates = defaultTemplate.concat(userTemplates);
    return templates;
    },
    nextStep() {
        this.$emit("nextStep", this.selectedId);
    }
  },
 
};
</script>

<style>
.template-table-card-text /deep/ .table-header-th {
    color: #ffffff !important;
}
.template-table-card-text /deep/ .v-data-table-header {
    font-family: "Noto Sans JP" !important;
    font-style: normal !important;
    background: var(--v-neutralGray-base) !important;
    color: #ffffff !important;
    height: 32px !important;
    min-height: 32px !important;
}
.subject-text-box {
  max-width: 700px;      /* limit width */
  word-wrap: break-word; /* break long words */
  overflow-wrap: break-word; /* modern replacement */
  white-space: normal;   /* allow wrapping */
}
</style>